import React from 'react';
import { FaStar } from 'react-icons/fa';

const MvpSuccessStories = () => {
    const testimonials = [
        {
            id: 1,
            author: "Deepak Ranga",
            title: "CEO & Founder, Analah Capital",
            initials: "DR",
            quote: "I would highly recommend ITCODE InfoTech and the team for fantastic work. Mr.Balkrushn is a good communicator and always gives reliable solutions to my queries”"
        },
        {
            id: 2,
            author: "Mahesh Chhotala",
            title: "Co-Founder, WhiteGlobe",
            initials: "MC",
            quote: "“Meeting the delivery deadlines or being  extremely prompt and reachable with all queries and follow ups, they're always here to help”"
        },
        {
            id: 3,
            author: "Anil Makim",
            title: "Founder, BOX2BUY",
            initials: "AM",
            quote: "The ITCODE InfoTech team quickly grasped our vision and had the skills to execute and create a fully-functional and amazing product for our MVP."
        }
    ];

    return (
        <div className="section bg-color-light mvp-stories-area" style={{paddingTop: "80px", paddingBottom: "20px"}}>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h2 className="title mb-5 fw-bold" style={{fontSize: "36px"}}>
                            Our clients' <span className="text-primary">Success Stories</span>
                        </h2>
                    </div>
                </div>
                <div className="row">
                    {testimonials.map(item => (
                        <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                            <div className="testimonial-card bg-white p-5 rounded-4 shadow-sm h-100 d-flex flex-column">
                                <div className="stars mb-4 d-flex gap-1">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-warning" size={16} />
                                    ))}
                                </div>
                                <div className="content mb-4 flex-grow-1">
                                    <p className="quote text-muted font-italic mb-0" style={{fontSize: "16px", lineHeight: "1.7"}}>
                                        "{item.quote}"
                                    </p>
                                </div>
                                <div className="author-info d-flex align-items-center mt-auto">
                                    <div className="avatar-initials bg-primary text-white d-flex align-items-center justify-content-center rounded-circle fw-bold me-3" style={{width: "50px", height: "50px", fontSize: "16px", minWidth: "50px"}}>
                                        {item.initials}
                                    </div>
                                    <div className="info">
                                        <h6 className="name mb-1 fw-bold text-dark" style={{fontSize: "16px"}}>{item.author}</h6>
                                        <p className="designation mb-0 text-muted" style={{fontSize: "14px"}}>{item.title}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MvpSuccessStories;
